module.exports = __webpack_public_path__ + "img/D户型2.fd572981.png";